<template>
    <v-select
        v-model="model"
        :label="`Country${required ? ' *' : ''}`"
        :items="sortedCountries"
        @update:modelValue="syncVModel"
        item-title="title"
        item-value="alpha2Code"
        @blur="$emit('blur')"
    >
        <template #item="{ item, props }">
            <v-divider v-if="'divider' in item.raw" />
            <v-list-item v-else v-bind="props">
                <template v-slot:prepend>{{ item.raw.flagEmoji }}&nbsp;&nbsp;</template>
            </v-list-item>
        </template>
        <template v-slot:selection="{ item }">{{ 'flagEmoji' in item.raw ? item.raw.flagEmoji : undefined }}&nbsp;&nbsp;{{ item.title }}</template>
    </v-select>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue'
import { localizedCountries } from '../../lib/LocalizedCountries'

const props = defineProps({
    modelValue: {
        type: String
    },
    required: {
        type: Boolean
    }
})

const allCountries = localizedCountries.getAllCountries()
const shortListCountries = localizedCountries.getShortListCountries()
const shortListCountriesCodes = shortListCountries.map((c) => c.alpha2Code)

const sortedCountries = computed(() => {
    const countriesExceptShortList = allCountries.filter((c) => {
        return shortListCountriesCodes.indexOf(c.alpha2Code) === -1
    })

    return [...shortListCountries, { divider: true }, ...countriesExceptShortList]
})

const model = ref<string | undefined>()

watch(
    () => props.modelValue,
    (value) => {
        model.value = value
    },
    { immediate: true }
)

const emit = defineEmits(['update:modelValue', 'blur'])

const syncVModel = () => {
    emit('update:modelValue', model.value)
}
</script>
